import {
  Radio,
  Table,
  Button,
  Checkbox,
  Popconfirm,
  Form,
  Input,
  Select,
  Space,
  Alert,
  Spin,
  message,
} from "antd";
import React from "react";
import { apiCallPost, indianRupee } from "../fns/util";
import _ from "lodash";

class RegistrationPage extends React.Component {
  state = {
    isLoading: false,
    redirect: false,
    primarySelectedType: null,
    linkedSelectedType: null,
    priceList: [],
    linkedPriceList: [],
    selectedItems: {},
    linkedSelectedItems: {},
    addPaymentInstrument: "UPI",
    addPaymentReference: "",
    sendingInvoice: false,
    makingPayment: false,
  };

  componentDidMount() {
    if (!this.props.primaryDelegate.isRegistered) {
      this.setState(
        {
          isLoading: true,
        },
        () => this.getRates()
      );
    }
  }
  getRates = async () => {
    let token = await this.props.context.provideToken();
    try {
      const res = await apiCallPost(
        token,
        "/conference2023/getCurrentApplicablePriceList",
        { targetId: this.props.primaryDelegate._id }
      );
      this.setState({
        priceList: res.priceList,
        linkedPriceList: res.linkedPriceList,
        isLoading: false,
      });
    } catch (err) {
      console.log(err);
      message.error("Error");
    }
  };
  handleTypeChange = (e, isLinked = false) => {
    const selectedType = e.target.value;
    if (isLinked) {
      this.setState({
        linkedSelectedType: selectedType,
        linkedSelectedItems:
          selectedType === "ITEM_WISE"
            ? { MEETING_REGN: true }
            : { ALL_IN_ONE: true },
      });
    } else {
      this.setState({
        primarySelectedType: selectedType,
        selectedItems:
          selectedType === "ITEM_WISE"
            ? { MEETING_REGN: true }
            : { ALL_IN_ONE: true },
      });
    }
  };
  handleSubmission = async (type) => {
    this.setState({
      makingPayment: true,
    });
    const primaryTotal = this.calculateTotal(
      this.state.selectedItems,
      this.state.priceList
    );
    const linkedTotal = this.calculateTotal(
      this.state.linkedSelectedItems,
      this.state.linkedPriceList
    );
    const grandTotal = primaryTotal + linkedTotal;

    let payload = {};
    if (type === "ONLINE") {
      payload = {
        lineItems: _.keys(this.state.selectedItems).map((each) => {
          return this.state.priceList.find((i) => i.itemCode === each);
        }),
        linkedLineItems: _.keys(this.state.linkedSelectedItems).map((each) => {
          return this.state.linkedPriceList.find((i) => i.itemCode === each);
        }),
      };

      let token = await this.props.context.provideToken();
      try {
        const res = await apiCallPost(
          token,
          "/conference2023/regn/payOnline",
          payload
        );
        if (res && res.rpPaymentLink && res.rpPaymentLink.short_url) {
          this.setState({
            redirect: res.rpPaymentLink.short_url,
          });
        }
        this.setState({
          makingPayment: false,
        });
        message.info("Redirecting you to payment page");
      } catch (err) {
        this.setState({
          makingPayment: false,
        });
        console.log(err);
        message.error("Error");
      }
    } else if (type === "OFFLINE") {
      let payload = {
        lineItems: _.keys(this.state.selectedItems).map((each) => {
          return this.state.priceList.find((i) => i.itemCode === each);
        }),
        linkedLineItems: _.keys(this.state.linkedSelectedItems).map((each) => {
          return this.state.linkedPriceList.find((i) => i.itemCode === each);
        }),
        targetId: this.props.primaryDelegate._id,
        paymentInfo: {
          instrument: this.state.addPaymentInstrument,
          reference: this.state.addPaymentReference,
          amount: grandTotal * 1.18,
        },
      };

      let token = await this.props.context.provideToken();
      try {
        let res = await apiCallPost(
          token,
          "/conference2023/regn/payOffline",
          payload
        );
        message.success("Successfully registered offline.");
        this.props.onDelegateUpdate(res.delegate);
        this.setState({
          makingPayment: false,
        });
      } catch (err) {
        this.setState({
          makingPayment: false,
        });
        console.log(err);
        message.error("Error");
      }
    }
  };
  handleSendInvoice = async () => {
    let token = await this.props.context.provideToken();
    try {
      message.loading("Sending invoice on email...");
      this.setState({
        sendingInvoice: true,
      });
      await apiCallPost(token, "/conference2023/regn/sendInvoice", {
        targetId: this.props.primaryDelegate._id,
      });
      message.success("Sent invoice on email.");

      this.setState({
        sendingInvoice: false,
      });
    } catch (err) {
      this.setState({
        sendingInvoice: false,
      });
      console.log(err);
      message.error("Error");
    }
  };
  renderSubmissionForm = () => {
    const { Option } = Select;
    return (
      <Form>
        <Form.Item label="Instrument">
          <Select
            value={this.state.addPaymentInstrument}
            onChange={(e) => {
              this.setState({
                addPaymentInstrument: e,
              });
            }}
          >
            <Option value="UPI">UPI</Option>
            <Option value="Cash">Cash</Option>
            <Option value="Cheque">Cheque</Option>
            <Option value="Bank Transfer">Bank Transfer</Option>
            <Option value="Wallet">Wallet</Option>
            <Option value="Others">Others</Option>
          </Select>
        </Form.Item>
        <Form.Item label="Reference">
          <Input
            value={this.state.addPaymentReference}
            onChange={(e) => {
              this.setState({ addPaymentReference: e.target.value });
            }}
          />
        </Form.Item>
      </Form>
    );
  };
  handleItemSelect = (itemCode, e, isLinked = false) => {
    const selectedItems = isLinked
      ? { ...this.state.linkedSelectedItems }
      : { ...this.state.selectedItems };
    selectedItems[itemCode] = e.target.checked;
    this.setState(
      isLinked ? { linkedSelectedItems: selectedItems } : { selectedItems }
    );
  };

  calculateTotal = (selectedItems, priceList, includeMeetingRegn = false) => {
    let total = 0;
    for (const code in selectedItems) {
      if (
        selectedItems[code] ||
        (includeMeetingRegn && code === "MEETING_REGN")
      ) {
        const item = priceList.find((i) => i.itemCode === code);
        if (item) {
          total += item.price;
        }
      }
    }
    return total;
  };
  renderAlreadyRegistered = () => {
    return (
      <Space direction="vertical">
        <h3>You have already registered.</h3>
        <Button
          onClick={this.handleSendInvoice}
          loading={this.state.sendingInvoice}
        >
          Resend Invoice on Email
        </Button>
        <h3>Details: </h3>
        <Space direction="vertical">
          {this.renderInclusionsIfAlreadyRegistered(this.props.primaryDelegate)}

          {this.props.linkedDelegate && (
            <>
              {this.renderInclusionsIfAlreadyRegistered(
                this.props.linkedDelegate
              )}
            </>
          )}
        </Space>
      </Space>
    );
  };

  renderRegnClosed = () => {
    return (
      <Space direction="vertical">
        <h3>Registrations are now Closed.</h3>
        <h3>Spot Registration will be available at the venue.</h3>
      </Space>
    );
  };

  renderInclusionsIfAlreadyRegistered = (delegate) => {
    let lineItems = delegate.lineItems;
    if (!lineItems || lineItems.length === 0) {
      return <div>{delegate.name}: No inclusions found</div>;
    }
    return (
      <Space direction="vertical">
        <div>
          <b>{delegate.name}</b>
        </div>
        {lineItems.map((each) => {
          return (
            <div>
              {each.item} - {indianRupee(each.price)} (
              {_.startCase(_.lowerCase(each.window))})
            </div>
          );
        })}
      </Space>
    );
  };
  renderSubmissionButton = () => {
    let showOffline = false;
    if (
      this.props.isAdmin &&
      this.props.primaryDelegate._id !== this.props.loggedInUser._id
    ) {
      showOffline = true;
    }

    if (
      _.keys(this.state.selectedItems).length === 0 ||
      (this.props.linkedDelegate &&
        _.keys(this.state.linkedSelectedItems).length === 0)
    ) {
      return null;
    }
    if (showOffline) {
      return (
        <Space direction="vertical" size="middle">
          {this.renderSubmissionForm()}
          {this.state.addPaymentInstrument &&
            this.state.addPaymentReference && (
              <Popconfirm
                title="Are you sure you want to record offline payment?"
                onConfirm={() => {
                  this.handleSubmission("OFFLINE");
                }}
                onCancel={() => {}}
                okText="Yes"
                cancelText="No"
              >
                <Button loading={this.state.makingPayment}>
                  Record Offline Payment
                </Button>
              </Popconfirm>
            )}
        </Space>
      );
    } else {
      const primaryTotal = this.calculateTotal(
        this.state.selectedItems,
        this.state.priceList
      );
      const linkedTotal = this.calculateTotal(
        this.state.linkedSelectedItems,
        this.state.linkedPriceList
      );
      if (primaryTotal + linkedTotal === 0) {
        return (
          <Alert
            message="It seems that you are attempting a complimentary registration. This can only be done by the administrator."
            type="error"
          />
        );
      }
      return (
        <Popconfirm
          title="Are you sure you want to register and pay? You cannot make changes later."
          onConfirm={() => {
            this.handleSubmission("ONLINE");
          }}
          onCancel={() => {}}
          okText="Yes"
          cancelText="No"
        >
          <Button type="primary" loading={this.state.makingPayment}>
            Register & Pay
          </Button>
        </Popconfirm>
      );
    }
  };
  renderTotals = () => {
    let showOffline = false;

    if (
      this.props.isAdmin &&
      this.props.primaryDelegate._id !== this.props.loggedInUser._id
    ) {
      showOffline = true;
    }
    const { primaryDelegate, linkedDelegate } = this.props;
    const allInOnePrice =
      this.state.priceList.find((i) => i.itemCode === "ALL_IN_ONE")?.price || 0;
    const linkedAllInOnePrice =
      this.state.linkedPriceList.find((i) => i.itemCode === "ALL_IN_ONE")
        ?.price || 0;
    const primaryTotal =
      this.state.primarySelectedType === "ALL_IN_ONE"
        ? allInOnePrice
        : this.calculateTotal(
            this.state.selectedItems,
            this.state.priceList,
            this.state.primarySelectedType === "ITEM_WISE"
          );

    const linkedTotal =
      this.state.linkedSelectedType === "ALL_IN_ONE"
        ? linkedAllInOnePrice
        : this.calculateTotal(
            this.state.linkedSelectedItems,
            this.state.linkedPriceList,
            this.state.linkedSelectedType === "ITEM_WISE"
          );

    const grandTotal = primaryTotal + linkedTotal;
    const taxAmount = grandTotal * 0.18;
    const feeAmount = showOffline ? 0 : (grandTotal + taxAmount) * 0.025;

    const grandTotalWithFees = grandTotal + taxAmount + feeAmount;
    return (
      <div style={{ margin: "20px 0" }}>
        <h3 style={{ marginBottom: "10px" }}>
          Total for {primaryDelegate.name}: {indianRupee(primaryTotal, 0)}
        </h3>
        {linkedDelegate && (
          <h3 style={{ marginBottom: "10px" }}>
            Total for {linkedDelegate.name}: {indianRupee(linkedTotal, 0)}
          </h3>
        )}
        <h3 style={{ marginBottom: "10px" }}>
          Subtotal: {indianRupee(grandTotal, 0)}
        </h3>
        <h3 style={{ marginBottom: "10px" }}>
          Tax (18% GST): {indianRupee(taxAmount, 0)}
        </h3>

        <h3 style={{ marginBottom: "10px" }}>
          Fees (2.5% Convenience Fee): {indianRupee(feeAmount, 0)}
        </h3>

        <h2 style={{ marginBottom: "10px" }}>
          Grand Total: {indianRupee(grandTotalWithFees, 0)}
        </h2>
      </div>
    );
  };
  render() {
    if (this.state.isLoading) {
      return <Spin />;
    }
    if (this.state.redirect) {
      window.location.href = this.state.redirect;
      return null;
    }

    if (this.props.primaryDelegate.isRegistered) {
      return this.renderAlreadyRegistered();
    }

    return this.renderRegnClosed();

    const { primaryDelegate, linkedDelegate } = this.props;
    const allInOnePrice =
      this.state.priceList.find((i) => i.itemCode === "ALL_IN_ONE")?.price || 0;
    const linkedAllInOnePrice =
      this.state.linkedPriceList.find((i) => i.itemCode === "ALL_IN_ONE")
        ?.price || 0;

    const columns = [
      { title: "Item", dataIndex: "item", key: "item" },
      this.state.primarySelectedType === "ITEM_WISE" && {
        title: primaryDelegate.name,
        dataIndex: "delegate",
        key: "delegate",
      },
      this.state.linkedSelectedType === "ITEM_WISE" &&
        linkedDelegate && {
          title: linkedDelegate.name,
          dataIndex: "linkedDelegate",
          key: "linkedDelegate",
        },
    ].filter((col) => col);
    const dataSource = this.state.priceList
      .filter((item) => item.itemCode !== "ALL_IN_ONE")
      .map((item) => {
        const linkedItem = this.state.linkedPriceList.find(
          (i) => i.itemCode === item.itemCode
        );
        const isCompulsory = item.itemCode === "MEETING_REGN";

        return {
          key: item.itemCode,
          item: item.item,
          delegate: (
            <div>
              {isCompulsory ? (
                ""
              ) : (
                <Checkbox
                  checked={this.state.selectedItems[item.itemCode]}
                  onChange={(e) => this.handleItemSelect(item.itemCode, e)}
                />
              )}
              {" " + indianRupee(item.price, 0)}
            </div>
          ),
          linkedDelegate: linkedDelegate ? (
            <div>
              {isCompulsory ? (
                ""
              ) : (
                <Checkbox
                  checked={this.state.linkedSelectedItems[linkedItem.itemCode]}
                  onChange={(e) =>
                    this.handleItemSelect(linkedItem.itemCode, e, true)
                  }
                />
              )}
              {" " + indianRupee(linkedItem.price, 0)}
            </div>
          ) : null,
        };
      });

    return (
      <div>
        <h1>Registration</h1>
        <Space direction="vertical">
          {" "}
          <Alert
            message={
              <span>
                <b>
                  If you have just made a payment, please wait for 10 minutes
                  before reattempting. You will receive an email with an invoice
                  shortly. It may take up to 10 minutes for your payment to
                  reflect in our systems. You can attempt this payment again if
                  you haven't received an invoice, or this page has not updated
                  upon refreshing even after 10 minutes.
                </b>
              </span>
            }
            type="info"
          />
          <Alert
            message="You can select the inclusions you want below. Note that you cannot change this later. Registrations and payments can be made online using various payment methods. However, if you are unable to make payments online, you should contact support - Mr Apurba Adhikary, at +919836340743."
            type="info"
          />
          <Alert
            message="You can choose to opt in for the all-in-one, complete registration that's inclusive of all meals and meeting registration. If you choose to pay for items individually, you will have to pay for the meeting registration as a mandatory fee."
            type="warning"
          />
          <Alert
            message={
              <span>
                You are currently eligible for the billing code for:{" "}
                <b>{primaryDelegate.billingPersona}</b>. If you believe you are
                eligible for further promotions or discounts, such as a New
                Member Discount or a Senior Member discount, you must contact
                support - Mr Apurba Adhikary, at +919836340743. This must be
                done prior to registration. Once registered, we will not be able
                to entertain any requests for adjustments or refunds.
              </span>
            }
            type="error"
          />
          {!linkedDelegate && (
            <Alert
              message="You have not added an accompanying delegate. Note that once your registration is done, your accompanying delegate cannot be added later - they can only register as a non-member. If you want to add an accompanying delegate now, switch to the 'Profile' tab from above, and add them."
              type="error"
            />
          )}
        </Space>{" "}
        <Space direction="vertical">
          <h3>{primaryDelegate.name}</h3>
          <Radio.Group
            onChange={(e) => this.handleTypeChange(e)}
            value={this.state.primarySelectedType}
          >
            <Radio value={"ALL_IN_ONE"}>
              All in One ({indianRupee(allInOnePrice, 0)})
            </Radio>
            <Radio value={"ITEM_WISE"}>Item Wise</Radio>
          </Radio.Group>

          {linkedDelegate && (
            <>
              <h3>{linkedDelegate.name}</h3>
              <Radio.Group
                onChange={(e) => this.handleTypeChange(e, true)}
                value={this.state.linkedSelectedType}
              >
                <Radio value={"ALL_IN_ONE"}>
                  All in One ({indianRupee(linkedAllInOnePrice, 0)})
                </Radio>
                <Radio value={"ITEM_WISE"}>Item Wise</Radio>
              </Radio.Group>
            </>
          )}
          {(this.state.primarySelectedType === "ITEM_WISE" ||
            this.state.linkedSelectedType === "ITEM_WISE") && (
            <Table dataSource={dataSource} columns={columns} />
          )}

          {this.renderTotals()}
          {this.renderSubmissionButton()}
        </Space>
      </div>
    );
  }
}

export default RegistrationPage;
